import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { MAX_TITLE_LENGTH } from '../../../../constants';
import { CustomExclusiveFieldName } from '../../types';

interface Props {}

const TitleField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: CustomExclusiveFieldName.TITLE, control });
  return (
    <TextInput
      id={id}
      maxLength={MAX_TITLE_LENGTH}
      label={t('customExclusivePopup.form.title.label')}
      placeholder={t('customExclusivePopup.form.title.placeholder')}
      value={value}
      onChange={onChange}
      autoFocus
      isRequired
      noBottomSpacing
    />
  );
};
TitleField.displayName = 'TitleField';

export default TitleField;
